import './atlantahistorycenter/style';
import FormStructure from './atlantahistorycenter/form_structure';

export default FormStructure;